import TableLoader from './TableLoader';

export default TableLoader;
